<template>
<div class="page-shell home-page">
  <HeadNav />

  <main>
    <section class="home-hero">
      <div class="site-container hero-stack">
        <h1>GB WhatsApp Pro APK v18.80 Download for Android</h1>
        <span class="hero-logo">
          <img class="hero-image" src="@/assets/gbwhata-home.webp" alt="GB WhatsApp Pro app icon">
        </span>

        <p class="hero-description">
          <strong>GB WhatsApp Pro v18.80</strong> is a modified version of WhatsApp for Android that adds more customization, privacy controls, and messaging features beyond the standard WhatsApp experience. The current release listed on this site is <strong>v18.80</strong>, with an APK size of approximately <strong>85 MB</strong>.
        </p>

        <div class="badge-row">
          <span class="info-badge light">Version: v18.80</span>
          <span class="info-badge light">APK Size: 85 MB</span>
          <span class="info-badge light">Platform: Android</span>
          <span class="info-badge light">File Type: APK</span>
        </div>

        <div class="hero-actions">
          <router-link class="button button-primary" to="/download/">
            <img class="button-icon" src="@/assets/android.svg" alt="">
            <span>Download GB WhatsApp Pro v18.80</span>
          </router-link>
        </div>
      </div>
    </section>

    <section class="site-section reading-section intro-section">
      <div class="site-container">
        <h2>What Is GB WhatsApp?</h2>
        <p>GB WhatsApp is an unofficial modified version of WhatsApp for Android. It is designed for users who want more control over the appearance, privacy settings, chats, and messaging features of the app.</p>
        <p>Depending on the version, <a href="https://gbwhata.io/"><strong>GB WhatsApp</strong></a> can include options such as <strong>custom themes, hidden chats, DND mode, scheduled messages, auto-reply, anti-revoke messages, and additional privacy controls.</strong></p>
        <p>Because it is a third-party modification rather than an official WhatsApp application, users should also understand the account, privacy, security, and compatibility considerations before installing it.</p>
      </div>
    </section>

    <section class="site-section soft install-section">
      <div class="site-container">
        <div class="section-heading">
          <h2>How to Download and Install GB WhatsApp</h2>
        </div>

        <div class="install-grid">
          <article v-for="(step, index) in installSteps" :key="step.title" class="install-card">
            <span class="install-number">{{ index + 1 }}</span>
            <h3>{{ step.title }}</h3>
            <p>{{ step.text }}<template v-if="step.strong"> <strong>{{ step.strong }}</strong>{{ step.tail }}</template></p>
          </article>
        </div>

        <div class="notice danger-note install-notice">
          <h3>Before Installing</h3>
          <p><strong>Back up important chats first.</strong> GB WhatsApp is an unofficial modified version of WhatsApp, so chat restoration may not work exactly the same way as it does with the official app. If you are switching from WhatsApp or updating an existing GB WhatsApp installation, make a backup before replacing the app.</p>
        </div>
      </div>
    </section>

    <section class="site-section features-section">
      <div class="site-container">
        <div class="section-heading">
          <h2>GB WhatsApp Features</h2>
          <p>GB WhatsApp focuses mainly on customization, privacy controls, and additional messaging options. Feature availability can vary between releases.</p>
        </div>

        <div class="grid three feature-grid">
          <article v-for="(feature, index) in features" :key="feature.title" class="surface-card feature-card" :class="{ 'feature-card-solo': index === features.length - 1 && features.length % 3 === 1 }">
            <span class="feature-index" :class="feature.tone" aria-hidden="true" v-html="feature.icon"></span>
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.text }}</p>
          </article>
        </div>
      </div>
    </section>

    <section class="site-section soft reading-section">
      <div class="site-container">
        <h2>What's New in GB WhatsApp v18.80?</h2>
        <p>The current version listed on this site is <strong>GB WhatsApp v18.80</strong>.</p>
        <p>The exact changes can vary depending on the specific GB WhatsApp build and its developer. Before updating, check the version information and make sure your existing chats and important files are backed up.</p>
        <p>If you are looking for an older release, compare version information carefully and understand the compatibility risks before installing any older APK.</p>
      </div>
    </section>

    <section class="site-section reading-section triple-section">
      <div class="site-container">
        <div class="triple-grid">
          <article class="reading-panel">
            <h2>GB WhatsApp Old Versions</h2>
            <p>Older GB WhatsApp releases can be useful if a newer version causes compatibility problems or removes a feature you prefer.</p>
            <p>However, older APKs may contain outdated components and may not work correctly with newer Android versions or WhatsApp services. Always check the version information before installing an older build.</p>
          </article>

          <article class="reading-panel">
            <h2>GB WhatsApp for iPhone</h2>
            <p>There is <strong>no native official GB WhatsApp version for iPhone</strong>. GB WhatsApp is primarily distributed as an Android APK and cannot be installed on iOS in the same way.</p>
            <p>Be careful with websites claiming to offer an official GB WhatsApp IPA or direct iPhone version, as these are not official WhatsApp releases.</p>
            <p>iPhone users who want the standard WhatsApp experience should use the official WhatsApp application available through Apple's App Store.</p>
          </article>

          <article class="reading-panel">
            <h2>GB WhatsApp on PC</h2>
            <p>GB WhatsApp does not provide a native Windows or macOS APK. If you want to run an Android APK on a computer, you would generally need a compatible Android emulator.</p>
            <p>For normal desktop messaging, the official WhatsApp desktop and web options are the more straightforward choice.</p>
          </article>
        </div>
      </div>
    </section>

    <section id="compare" class="site-section soft compare-section">
      <div class="site-container">
        <div class="section-heading">
          <h2>GB WhatsApp vs Official WhatsApp</h2>
        </div>

        <div class="table-scroll">
          <table class="site-table compare-table">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Official WhatsApp</th>
                <th>GB WhatsApp</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in comparisonRows" :key="row.feature">
                <td><strong>{{ row.feature }}</strong></td>
                <td>{{ row.official }}</td>
                <td>{{ row.gb }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p class="compare-note">Feature availability can change between GB WhatsApp versions, so individual functions should not be treated as guaranteed across every release.</p>
      </div>
    </section>

    <section class="site-section">
      <div class="site-container">
        <div class="section-heading">
          <h2>Advantages and Disadvantages</h2>
        </div>

        <div class="pros-cons">
          <div class="pros">
            <h3>Advantages</h3>
            <ul class="check-list">
              <li v-for="item in advantages" :key="item">{{ item }}</li>
            </ul>
          </div>
          <div class="cons">
            <h3>Disadvantages</h3>
            <ul class="check-list">
              <li v-for="item in disadvantages" :key="item">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="site-section soft">
      <div class="site-container">
        <div class="section-heading">
          <h2>Frequently Asked Questions</h2>
        </div>

        <div class="faq-list">
          <details v-for="item in faqs" :key="item.question" class="faq-item">
            <summary>{{ item.question }}</summary>
            <p>{{ item.answer }}</p>
          </details>
        </div>
      </div>
    </section>

    <section class="site-section reading-section final-download">
      <div class="site-container">
        <h2>Before You Download</h2>
        <p>GB WhatsApp offers features that are not available or are more limited in the standard WhatsApp experience, but it also comes with additional considerations.</p>
        <p>WhatsApp does not officially support modified clients, and using an unofficial version can result in account restrictions. Privacy, security, compatibility, and chat restoration can also vary depending on the specific GB WhatsApp build.</p>
        <p>If your WhatsApp number is important for work, business, banking-related communication, or long-term contacts, consider these risks before replacing the official app.</p>
        <p>If you decide to use GB WhatsApp, download only the version you intend to install and keep a backup of important chats before making changes to your existing WhatsApp installation.</p>
      </div>
    </section>
  </main>
</div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    const icon = (inner) =>
      '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      inner +
      '</svg>';

    return {
      installSteps: [
        {
          title: 'Download the APK',
          text: 'Tap the download button and save the GB WhatsApp APK to your Android device.',
        },
        {
          title: 'Open the downloaded file',
          text: 'Go to your Downloads folder and tap the APK file to start the installation.',
        },
        {
          title: 'Allow installation from unknown sources',
          text: 'If Android blocks the installation, open the settings shown in the prompt and allow your browser or file manager to install unknown apps. The exact menu name can vary between Android phones.',
        },
        {
          title: 'Install GB WhatsApp',
          text: 'Return to the APK file and tap',
          strong: 'Install',
          tail: '. Wait for the installation to finish.',
        },
        {
          title: 'Open and verify your number',
          text: 'Launch GB WhatsApp and follow the on-screen steps to enter and verify your phone number.',
        },
      ],
      features: [
        {
          title: 'Advanced Customization',
          tone: 'tone-green',
          icon: icon(
            '<line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/>'
          ),
          text: 'Change the appearance of WhatsApp with custom themes, wallpapers, fonts, colors, and other interface options. Some versions also provide additional styling controls for chats and menus.',
        },
        {
          title: 'Enhanced Privacy Controls',
          tone: 'tone-blue',
          icon: icon('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>'),
          text: 'GB WhatsApp provides additional options for controlling what other people can see. Depending on the version, these may include hiding online status, last seen, typing indicators, and read receipts.',
        },
        {
          title: 'Anti-Revoke Messages',
          tone: 'tone-amber',
          icon: icon(
            '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/>'
          ),
          text: 'Some versions include an anti-revoke feature that can keep certain messages or media visible after the sender deletes them.',
        },
        {
          title: 'DND Mode',
          tone: 'tone-blue',
          icon: icon('<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>'),
          text: 'DND mode lets you temporarily pause WhatsApp activity without putting your entire phone into Do Not Disturb or Airplane Mode. Other apps can continue working normally while WhatsApp remains paused.',
        },
        {
          title: 'Scheduled Messages',
          tone: 'tone-green',
          icon: icon('<circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>'),
          text: 'Schedule messages to be sent at a specific time instead of sending them manually. This can be useful for reminders, greetings, or messages that need to go out at a particular time.',
        },
        {
          title: 'Auto Reply',
          tone: 'tone-amber',
          icon: icon(
            '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>'
          ),
          text: 'Set automatic responses for incoming messages when you are unavailable. This feature can be useful when you cannot respond immediately.',
        },
        {
          title: 'Hidden Chats and App Lock',
          tone: 'tone-green',
          icon: icon('<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>'),
          text: 'Keep selected conversations away from the main chat list and add an extra lock where supported. GB WhatsApp versions may offer PIN, password, fingerprint, or other device-supported locking methods.',
        },
        {
          title: 'Status Tools',
          tone: 'tone-blue',
          icon: icon(
            '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>'
          ),
          text: 'Some versions provide additional options for viewing, downloading, or customizing WhatsApp Status content.',
        },
        {
          title: 'Larger File and Media Options',
          tone: 'tone-amber',
          icon: icon(
            '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>'
          ),
          text: 'Depending on the release, GB WhatsApp may allow larger files or provide additional options for preserving media quality when sending photos and videos.',
        },
        {
          title: 'Multiple Accounts',
          tone: 'tone-green',
          icon: icon(
            '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>'
          ),
          text: 'Some versions support using more than one WhatsApp account on the same Android device, which can be useful for separating personal and other conversations.',
        },
      ],
      comparisonRows: [
        { feature: 'Custom themes', official: 'Limited', gb: 'More options' },
        { feature: 'Interface customization', official: 'Limited', gb: 'Extensive' },
        { feature: 'Hide online status', official: 'Available controls', gb: 'Additional controls' },
        { feature: 'Hide typing status', official: 'Limited', gb: 'Available in supported versions' },
        { feature: 'Anti-revoke messages', official: 'No', gb: 'Available in supported versions' },
        { feature: 'Scheduled messages', official: 'Limited', gb: 'Available in supported versions' },
        { feature: 'Auto reply', official: 'Available in specific official products', gb: 'Available in supported versions' },
        { feature: 'Hidden chats', official: 'Limited', gb: 'Available in supported versions' },
        { feature: 'Multiple accounts', official: 'Supported', gb: 'Supported in some versions' },
        { feature: 'Official support', official: 'Yes', gb: 'No' },
      ],
      advantages: [
        'More customization options',
        'Additional privacy controls',
        'Extra messaging features',
        'More control over chats and status',
        'Multiple-account options on supported devices',
        'More interface personalization',
      ],
      disadvantages: [
        'It is not an official WhatsApp application',
        'Your account may face restrictions',
        'Updates usually require manual APK installation',
        'Compatibility can vary between versions',
        'Security and privacy practices cannot be verified in the same way as the official WhatsApp app',
      ],
      faqs: [
        {
          question: 'Is GB WhatsApp an official WhatsApp app?',
          answer: 'No. GB WhatsApp is a third-party modified version of WhatsApp and is not developed or officially distributed by WhatsApp.',
        },
        {
          question: 'Is GB WhatsApp safe?',
          answer: 'There is no way to provide the same security assurance as the official WhatsApp application because GB WhatsApp is an unofficial modification. Users should consider the source of the APK and the risks associated with installing modified apps.',
        },
        {
          question: 'Can GB WhatsApp get my account banned?',
          answer: 'Yes. WhatsApp states that using unofficial versions of WhatsApp can result in temporary or permanent account restrictions. There is no genuine anti-ban feature that can guarantee your account will not be restricted.',
        },
        {
          question: 'Can I use GB WhatsApp on iPhone?',
          answer: 'There is no native official GB WhatsApp version for iPhone. GB WhatsApp is primarily distributed as an Android APK.',
        },
        {
          question: 'Can I use two accounts with GB WhatsApp?',
          answer: 'Some GB WhatsApp versions support multiple accounts, but the exact options depend on the version and Android device.',
        },
        {
          question: 'Is GB WhatsApp free?',
          answer: 'GB WhatsApp is generally distributed as a free APK. Be cautious of websites that ask you to pay for the APK or provide unnecessary personal information before downloading it.',
        },
        {
          question: 'Can I update GB WhatsApp without losing my chats?',
          answer: 'You should back up important chats before updating. Because GB WhatsApp is an unofficial app, restoration behavior can vary between versions.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.home-hero {
  position: relative;
  overflow: hidden;
  padding: 86px 0 74px;
  background:
    radial-gradient(85% 120% at 50% -10%, rgba(22, 163, 74, 0.18) 0%, rgba(22, 163, 74, 0) 62%),
    linear-gradient(rgba(22, 163, 74, 0.055) 1px, transparent 1px),
    linear-gradient(90deg, rgba(22, 163, 74, 0.055) 1px, transparent 1px),
    linear-gradient(180deg, #e9f5ee 0%, #f7fbf9 100%);
  background-size: auto, 44px 44px, 44px 44px, auto;
  border-bottom: 1px solid var(--line);
}

.hero-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.hero-logo {
  display: inline-flex;
  width: 132px;
  height: 132px;
  align-items: center;
  justify-content: center;
  margin: 2px 0 30px;
  border-radius: 30px;
  background: #ffffff;
  box-shadow: 0 20px 46px rgba(16, 37, 27, 0.18);
}

.hero-image {
  display: block;
  width: 108px;
  height: 108px;
  border-radius: 24px;
}

.hero-stack h1 {
  max-width: 980px;
  margin-bottom: 24px;
  color: var(--ink);
  font-size: clamp(30px, 4.1vw, 42px);
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.14;
}

.hero-description {
  max-width: 760px;
  margin-bottom: 0;
  color: var(--ink-soft);
  font-size: 18px;
}

.hero-stack .badge-row {
  justify-content: center;
}

.home-page .site-section {
  padding: 76px 0;
}

/* One centered title axis + one reading measure gives the page a steady rhythm. */
.home-page .section-heading {
  max-width: 760px;
  margin: 0 auto 44px;
  text-align: center;
}

.reading-section .site-container > * {
  max-width: 880px;
  margin-right: auto;
  margin-left: auto;
}

/* Frame the text sections so they line up with the card and table modules. */
.reading-section .site-container {
  padding: 40px 48px;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: #ffffff;
  box-shadow: var(--shadow-sm);
}

.reading-section p {
  font-size: 17px;
}

/* Three short topics share one row and stay framed like the other modules. */
.reading-section.triple-section .site-container {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.reading-section.triple-section .site-container > * {
  max-width: none;
}

.triple-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  align-items: stretch;
}

.reading-panel {
  padding: 34px 32px;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: #ffffff;
  box-shadow: var(--shadow-sm);
  transition:
    transform 180ms ease,
    box-shadow 180ms ease,
    border-color 180ms ease;
}

.reading-panel:hover {
  transform: translateY(-4px);
  border-color: #bee8c8;
  box-shadow: var(--shadow-md);
}

.reading-panel h2 {
  font-size: 20px;
}

.reading-panel p {
  font-size: 15.5px;
}

.reading-panel p:last-child {
  margin-bottom: 0;
}

.reading-section h2 {
  text-align: center;
}

.home-page .site-section h2::before {
  display: block;
  width: 52px;
  height: 4px;
  margin: 0 auto 18px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--green) 0%, #4ade80 100%);
  content: '';
}

.intro-section p a {
  color: var(--green-dark);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
}

.intro-section p a:hover {
  color: var(--green);
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 32px;
}

.hero-actions .button {
  min-height: 56px;
  padding: 16px 28px;
  font-size: 16px;
}

.install-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
}

.install-card {
  min-height: 200px;
  padding: 24px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #ffffff;
  box-shadow: var(--shadow-sm);
  transition:
    transform 180ms ease,
    box-shadow 180ms ease,
    border-color 180ms ease;
}

.install-card:hover {
  transform: translateY(-4px);
  border-color: #bee8c8;
  box-shadow: var(--shadow-md);
}

.install-number {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  margin-bottom: 22px;
  border-radius: 10px;
  background: var(--green);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 8px 18px rgba(22, 163, 74, 0.28);
}

.install-card p {
  margin-bottom: 0;
  font-size: 14px;
}

.install-notice {
  margin-top: 26px;
}

.install-notice h3 {
  margin-bottom: 8px;
  color: #8a2c17;
}

.features-section {
  background: #ffffff;
}

.feature-grid {
  align-items: stretch;
}

@media (min-width: 981px) {
  .feature-grid .feature-card-solo {
    grid-column: 2;
  }
}

.compare-note {
  max-width: 760px;
  margin: 22px auto 0;
  color: var(--muted);
  font-size: 15px;
  text-align: center;
}

.pros-cons li::before {
  color: #0d6b39;
}

.final-download {
  padding-bottom: 76px;
  background: #ffffff;
}

@media (max-width: 1040px) {
  .install-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 980px) {
  .triple-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 820px) {
  .install-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .reading-section .site-container {
    padding: 30px 22px;
  }

  .reading-section .site-container > * {
    max-width: none;
  }
}

@media (max-width: 600px) {
  .home-hero {
    padding-top: 56px;
  }

  .hero-logo {
    width: 116px;
    height: 116px;
    margin: 2px 0 24px;
    border-radius: 26px;
  }

  .hero-image {
    width: 94px;
    height: 94px;
    border-radius: 20px;
  }

  .hero-actions,
  .hero-actions .button {
    width: 100%;
  }

  .install-grid {
    grid-template-columns: 1fr;
  }

  .install-card {
    min-height: 0;
  }

  .reading-panel {
    padding: 26px 22px;
  }
}
</style>
